// Public website realtime client (price sync + live chat)
const WS_URL = "wss://xlttvj535e.execute-api.ap-south-1.amazonaws.com/prod";

let socket = null;
let manualClose = false;
let reconnectTimer = null;
let pingTimer = null;
const listeners = new Set();

export function onRealtime(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
const _recent = new Map(); // de-dupe identical events delivered by >1 socket
function emit(e) {
  if (e && e.type !== "__status") {
    const key = JSON.stringify(e);
    const now = Date.now();
    const seen = _recent.get(key);
    if (seen && now - seen < 8000) return;
    _recent.set(key, now);
    if (_recent.size > 60) for (const [k, t] of _recent) if (now - t > 8000) _recent.delete(k);
  }
  listeners.forEach((fn) => { try { fn(e); } catch {} });
}

export function connectRealtime() {
  manualClose = false;
  // idempotent: reuse an existing live/connecting socket (pricing + chat share one)
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return;
  try { socket = new WebSocket(`${WS_URL}?role=public`); }
  catch { schedule(); return; }

  socket.onopen = () => {
    emit({ type: "__status", online: true });
    clearInterval(pingTimer);
    pingTimer = setInterval(() => { try { socket.send(JSON.stringify({ action: "ping" })); } catch {} }, 9 * 60 * 1000);
  };
  socket.onmessage = (e) => { try { emit(JSON.parse(e.data)); } catch {} };
  socket.onclose = () => {
    clearInterval(pingTimer);
    emit({ type: "__status", online: false });
    if (!manualClose) schedule();
  };
  socket.onerror = () => { try { socket.close(); } catch {} };
}
function schedule() { clearTimeout(reconnectTimer); reconnectTimer = setTimeout(connectRealtime, 3000); }

export function sendRealtime(obj) { try { socket?.send(JSON.stringify(obj)); } catch {} }
export function closeRealtime() {
  manualClose = true;
  clearTimeout(reconnectTimer); clearInterval(pingTimer);
  try { socket?.close(); } catch {}
}
